var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandSofar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.396,
    height: 26.032,
    viewBox: "0 0 140.396 26.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_6",
    "data-name": "\\u7EC4 6",
    transform: "translate(-167 108.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_360",
    "data-name": "\\u8DEF\\u5F84 360",
    d: "M140.66,29.86,134.46,21A8.52,8.52,0,0,0,130.9,4.74H119a2.56,2.56,0,0,0-2.56,2.55V30a.26.26,0,0,0,.26.25H121a.25.25,0,0,0,.25-.25V9h9.14a4.24,4.24,0,1,1,0,8.48h-6.74a.25.25,0,0,0-.25.26v3.77a.26.26,0,0,0,.25.26h3.58a3.89,3.89,0,0,1,3.07,1.64l4.63,6.62a.51.51,0,0,0,.42.21h5.1a.25.25,0,0,0,.21-.38Z",
    transform: "translate(166.7 -113.22)",
    fill: "#3a70d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_361",
    "data-name": "\\u8DEF\\u5F84 361",
    d: "M113.88,29.9,103.17,7A3.82,3.82,0,0,0,99.7,4.74H97.46A3.82,3.82,0,0,0,94,7l-3.75,8a.26.26,0,0,0,.23.37H95a.51.51,0,0,0,.46-.3l2.71-5.8A.42.42,0,0,1,98.58,9h0a.44.44,0,0,1,.38.24l3.84,8.24H91.51A3.82,3.82,0,0,0,88,19.71L83.29,29.9a.25.25,0,0,0,.23.36h4.57a.5.5,0,0,0,.46-.29l3.51-7.53a1.13,1.13,0,0,1,1-.65h11a1.12,1.12,0,0,1,1,.65L108.61,30a.52.52,0,0,0,.46.29h4.57a.26.26,0,0,0,.24-.39Z",
    transform: "translate(166.7 -113.22)",
    fill: "#3a70d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_362",
    "data-name": "\\u8DEF\\u5F84 362",
    d: "M83,17.5H66.36V11.58A2.56,2.56,0,0,1,68.92,9H82.36a.5.5,0,0,0,.46-.29l1.7-3.63a.25.25,0,0,0-.23-.36H68a6.38,6.38,0,0,0-6.39,6.38V30a.26.26,0,0,0,.26.25h4.29a.25.25,0,0,0,.25-.25V21.79H81.08a.53.53,0,0,0,.47-.3l1.69-3.63A.25.25,0,0,0,83,17.5Z",
    transform: "translate(166.7 -113.22)",
    fill: "#3a70d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_363",
    "data-name": "\\u8DEF\\u5F84 363",
    d: "M18.37,15.36H8.26A3.18,3.18,0,1,1,8.26,9H21.12a.52.52,0,0,0,.46-.29L23.27,5.1A.25.25,0,0,0,23,4.74H7.75a7.45,7.45,0,1,0,0,14.9H17.86a3.17,3.17,0,0,1,0,6.34H3.39a.52.52,0,0,0-.47.29L1.23,29.9a.25.25,0,0,0,.23.36H18.37a7.45,7.45,0,0,0,0-14.9Z",
    transform: "translate(166.7 -113.22)",
    fill: "#3a70d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_10",
    "data-name": "\\u77E9\\u5F62 10",
    width: 7.66,
    height: 7.66,
    rx: 1.28,
    transform: "translate(215.25 -108.49)",
    fill: "#5fc8ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_364",
    "data-name": "\\u8DEF\\u5F84 364",
    d: "M56.13,14.53H51.81a.25.25,0,0,0-.25.27,38,38,0,0,1-.1,6.66A5.12,5.12,0,0,1,46.87,26a42.21,42.21,0,0,1-8.41,0,5.11,5.11,0,0,1-4.59-4.57,37.35,37.35,0,0,1,0-7.91A5.09,5.09,0,0,1,38.42,9a41.37,41.37,0,0,1,7.71-.06.26.26,0,0,0,.28-.25V4.84a.26.26,0,0,0-.25-.26,66.391,66.391,0,0,0-9,.13,8.88,8.88,0,0,0-8.07,8.11,56.14,56.14,0,0,0,0,9.35,8.94,8.94,0,0,0,8.2,8.13,67.14,67.14,0,0,0,10.8,0,8.91,8.91,0,0,0,8.2-8.06,54.62,54.62,0,0,0,.13-7.46.26.26,0,0,0-.29-.25Z",
    transform: "translate(166.7 -113.22)",
    fill: "#3a70d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSofar);
export default __webpack_public_path__ + "static/media/brand_sofar.a412f5548039a4562903bba0af19b837.svg";
export { ForwardRef as ReactComponent };